'use strict';
import React from 'react';
import classNames from 'classnames';

/**
 * Icon styles are available via the icons.scss file, icons.css or all.css files.
 * Standard icon size is 45px.
 * Icon styles can be applied to any inline or block element.
 * Base Icon style should be applied along with the Icon-- modifier style.
 * Note that the :before pseudo element is used to display the icon.
 *
 * Usage:
 *
 * ```Javascript
 * <Icon iconClass="add" />
 * ```
 *
 * @extends {React.Component}
 * @property {String} className Sets any given classname that might be required in this component.
 * @property {Boolean} disabled Renders the Icon as disabled.
 * @property {String} iconClass Sets the icon image that will be used.
 */
class Icon extends React.Component {

  /**
   * @return {String} Component CSS classname.
   */
  getClassName () {
    return classNames({
      [`${this.props.className}`]: !!this.props.className,
      'Icon': true,
      [`Icon--${this.props.iconClass}`]: !!this.props.iconClass,
      'is-disabled': this.props.disabled
    });
  }

  /**
   * @return {JSX} JSX component markup.
   */
  render () {
    return (
      <span className={this.getClassName()}></span>
    );
  }
}

/**
 * @prop {propTypes} propTypes attributes for the Icon component
 */
Icon.propTypes = {
  disabled: React.PropTypes.bool,
  iconClass: React.PropTypes.oneOf([
    'add', 'approve', 'arrowLeft', 'arrowRight', 'attach', 'block', 'box', 'boxChecked', 'calendar', 'chevronDown', 'chevronLeft',
    'chevronRight', 'chevronUp', 'close', 'collapse', 'creatives', 'dashboard', 'doubleChevronDown', 'doubleChevronLeft',
    'doubleChevronRight', 'doubleChevronUp', 'download', 'error', 'expand', 'expandWindow', 'facebook', 'file', 'filter', 'flag',
    'folder', 'google', 'information', 'linkedIn', 'management', 'more', 'pdf', 'print', 'radio', 'radioSelect', 'refresh', 'reports',
    'save', 'search', 'settings', 'sortDown', 'sortLeft', 'sortRight', 'sortUp', 'success', 'summary', 'trash', 'twitter', 'upload',
    'users', 'warning', 'youtube'
  ])
};

Icon.defaultProps = {
  disabled: false
};

export default Icon;



// WEBPACK FOOTER //
// ./src/components/clarity-ui/components/icon.jsx